import React from "react";
import { useSeo } from "../../site/ui";
import { WayCards } from "./LaonaWays";

/* 프로젝트 시작 — 직접 만들기(무료, PinWire) 또는 라오나봇과 만들기(무료로 시작) 카드를 누르면
   프로젝트 만들기 팝업이 뜬다 (LaonaWays). ?way=manual|bot 으로 들어오면 팝업이 바로 열린다 */
export default function LaonaStart() {
  useSeo({ title: "프로젝트 시작하기 — LaonaBot", path: "/laonabot/start" });
  return (
    <section className="lb-section lb-section--top">
      <div className="lb-wrap">
        <header className="lb-head">
          <p className="lb-kicker">NEW PROJECT</p>
          <h1>어떻게 만들까요?</h1>
          <p className="lb-lead">시제품을 만들 방법을 고르세요. 카드를 누르면 새 프로젝트를 만듭니다.</p>
        </header>
        <WayCards />
      </div>
    </section>
  );
}
